<section class="makePaymentPage__invoicesTable my-4">
  <div class="makePaymentPage__tableHeader container py-3">
    <div class="makePaymentPage__tableHeaderRow row d-none d-lg-flex">
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.status' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.credit#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-2">{{ 'makeAPayment.account#' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.credit_date' | cxTranslate }}</div>
      <div class="makePaymentPage__tableHeaderCell col-3">{{ 'makeAPayment.credit_amount' | cxTranslate }}</div>
    </div>
  </div>
  <div class="makePaymentPage__tableBody container">
    @for (credit of paymentResponse()?.creditMemoPaymentResponse?.invoiceCreditPayResponseList; track credit.credNum) {
      <div class="makePaymentPage__tableRow row flex-column flex-lg-row my-3 py-4">
        <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
          <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.status' | cxTranslate }}: </div>
          <div class="d-flex align-items-center">
            {{
              ['makeAPayment.confirmationStep.transactionStatus__processing', 'makeAPayment.confirmationStep.transactionStatus__unknown'] |
                cxTranslate: {context: paymentResponse()?.transactionStatus?.toLowerCase()}
            }}
          </div>
        </div>


        <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex flex-lg-column align-items-lg-start flex-wrap align-content-lg-start">
          <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit#' | cxTranslate }}: </div>
          @for (credNum of credit?.credNum?.split(',') || []; track credNum) {
            <a href="javascript: void(0);" class="underline mb-lg-1 mr-1 mr-lg-0" (click)="invoicePdf(credNum)">{{ credNum }}</a>
          }
        </div>

        <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
          <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.account#' | cxTranslate }}: </div>
          <span>{{ userId() }}</span>
        </div>

        <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
          <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit_date' | cxTranslate }}: </div>
          <span> {{ currentDate() | date : 'MM/dd/yyyy' }}</span>
        </div>

        <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
          <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.credit_amount' | cxTranslate }}: </div>
          <span>{{ credit.credAmt }}</span>
        </div>
      </div>
    }

    <sanofi-no-items-disclaimer
      [itemsList]="paymentResponse()?.creditMemoPaymentResponse?.invoiceCreditPayResponseList"
      [text]="'makeAPayment.noInvoicesToDisplay' | cxTranslate"
      [mix]="'makePaymentPage__tableRow'"
    />
  </div>
</section>
